import React, { useState } from 'react';
import './PracticeTranscriptionPanel.css';

const PracticeTranscriptionPanel = ({
    selectedExcerpt,
    userInputs,
    onInputChange,
    checkedResults,
    isChecked
}) => {
    const [showCorrectText, setShowCorrectText] = useState(false);

    if (!selectedExcerpt) return null;

    // Determine the number of lines we need to display
    const lineCount = selectedExcerpt.lineCount ||
        (Array.isArray(selectedExcerpt.lines) ? selectedExcerpt.lines.length : 0) ||
        parseInt(selectedExcerpt.lines);

    // Create an array of line indices
    const lineIndices = Array.from({ length: lineCount }, (_, i) => i);

    return (
        <div className="practice-transcription-panel">
            <div className="practice-panel-header">
                <h3>Transcribe Each Line</h3>
                {isChecked && (
                    <button 
                        className={`toggle-correct-text ${showCorrectText ? 'active' : ''}`}
                        onClick={() => setShowCorrectText(!showCorrectText)}
                    >
                        {showCorrectText ? "Hide Correct Transcription" : "Display Correct Transcription"}
                    </button>
                )}
            </div>

            <div className="practice-transcription-content">
                {lineIndices.map((lineIndex) => (
                    <div key={lineIndex} className="practice-line-item">
                        <div className="line-number">{lineIndex + 1}</div>

                        {isChecked ? (
                            <div className="checked-content">
                                {showCorrectText && (
                                    <div className="correct-transcription" dir="rtl">
                                        {checkedResults[lineIndex]?.comparison.map((token, tokenIndex) => (
                                            <span
                                                key={tokenIndex}
                                                className={!token.isCorrect ? 'error-highlight' : ''}
                                            >
                                                {token.correctToken}{' '}
                                            </span>
                                        ))}
                                    </div>
                                )}
                                
                                <div 
                                    className="user-transcription" 
                                    dir="rtl"
                                    style={{
                                        borderTopLeftRadius: !showCorrectText ? '5px' : '0',
                                        borderTopRightRadius: !showCorrectText ? '5px' : '0',
                                        borderTop: !showCorrectText ? '1px solid #ddd' : 'none'
                                    }}
                                >
                                    {checkedResults[lineIndex]?.comparison.map((token, tokenIndex) => (
                                        <span
                                            key={tokenIndex}
                                            className={token.isCorrect ? 'correct-token' : 'error-token'}
                                        >
                                            {token.userToken}{' '}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div className="input-container">
                                <textarea
                                    dir="rtl"
                                    value={userInputs[lineIndex] || ''}
                                    onChange={(e) => onInputChange(lineIndex, e.target.value)}
                                    className="arabic-input"
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PracticeTranscriptionPanel;